import { useCallback, useState } from 'react';
import { Button } from '@tryhackme/thm-ui-components';
import { DeleteModal } from 'src/common/delete-modal';
import { TagCategoriesProps } from 'src/features/admin/tagging/tagging.types';
import { StyledAddTagCategory, StyledTagCards } from 'src/features/admin/tagging/tagging.styles';
import { TagCategoryCard } from 'src/features/admin/tagging/components/cards/tag-category-card';
import { TagCategoryHelpModal } from 'src/features/admin/tagging/components/modals/tag-category-help-modal';
import { AddTagCategoryModal } from 'src/features/admin/tagging/components/modals/add-tag-category-modal';
export const TagCategories = ({
  createTagCategory,
  deleteTagCategory,
  updateTagCategory,
  tagCategories,
  isCreating,
  createdTagCategory,
  resetCreateTagCategory
}: TagCategoriesProps) => {
  const [addTagCategoryModalOpen, setAddTagCategoryModalOpen] = useState(false);
  const [selectedParentCategoryId, setSelectedParentCategoryId] = useState<string>();
  const [deleteTagCategoryModalOpen, setDeleteTagCategoryModalOpen] = useState(false);
  const [activeTagCategoryId, setActiveTagCategoryId] = useState<string>();
  const [helpModalOpen, setHelpModalOpen] = useState(false);
  const allCategoryLabels = [...tagCategories.map(tc => tc.label), ...tagCategories.flatMap(tc => tc.subcategories).map(tc => tc.label)];
  const handleModalDelete = useCallback(() => {
    if (activeTagCategoryId) {
      deleteTagCategory(activeTagCategoryId);
    }
    setDeleteTagCategoryModalOpen(false);
  }, [activeTagCategoryId, deleteTagCategory]);
  const handleDeletePress = (id: string) => {
    setActiveTagCategoryId(id);
    setDeleteTagCategoryModalOpen(true);
  };
  return <StyledTagCards data-sentry-element="StyledTagCards" data-sentry-component="TagCategories" data-sentry-source-file="tag-categories.tsx">
      <StyledAddTagCategory data-sentry-element="StyledAddTagCategory" data-sentry-source-file="tag-categories.tsx">
        <Button variant="solid" onClick={() => setHelpModalOpen(true)} data-sentry-element="Button" data-sentry-source-file="tag-categories.tsx">
          Help
        </Button>
        <Button onClick={() => {
        // eslint-disable-next-line unicorn/no-useless-undefined
        setSelectedParentCategoryId(undefined);
        setAddTagCategoryModalOpen(true);
      }} data-sentry-element="Button" data-sentry-source-file="tag-categories.tsx">
          Add Category
        </Button>
      </StyledAddTagCategory>
      <AddTagCategoryModal handleCreateTagCategory={createTagCategory} isOpen={addTagCategoryModalOpen} setIsOpen={setAddTagCategoryModalOpen} isCreating={isCreating} createdTagCategory={createdTagCategory} resetCreateTagCategory={resetCreateTagCategory} parentCategory={selectedParentCategoryId} existingCategoryLabels={allCategoryLabels} data-sentry-element="AddTagCategoryModal" data-sentry-source-file="tag-categories.tsx" />
      <DeleteModal open={deleteTagCategoryModalOpen} onOpenChange={setDeleteTagCategoryModalOpen} modalTitleText="Delete Tag Category" modalBodyText={<div>
            <p>
              A tag category can only be deleted if it is not the parent of any other categories and if it is not in use
              by any tags.
            </p>
            <br />
            <p>Are you sure you want to delete this tag category?</p>
          </div>} handleDeleteAction={handleModalDelete} activeIndex={0} data-sentry-element="DeleteModal" data-sentry-source-file="tag-categories.tsx" />
      <TagCategoryHelpModal open={helpModalOpen} onOpenChange={open => setHelpModalOpen(open)} data-sentry-element="TagCategoryHelpModal" data-sentry-source-file="tag-categories.tsx" />
      {tagCategories.map(tagCategory => <TagCategoryCard key={`tag-category-${tagCategory._id}`} createTagCategory={createTagCategory} deleteTagCategory={handleDeletePress} updateTagCategory={updateTagCategory} tagCategory={tagCategory} setAddTagCategoryModalOpen={setAddTagCategoryModalOpen} setSelectedParentCategoryId={setSelectedParentCategoryId} />)}
    </StyledTagCards>;
};